import {AppStore, setMenuOpen} from "../useAppPullState";

export const useDrawer = () => {
    const {
        showHistory,
        authUser,
        open,
    } = AppStore.useState(s => ({
        showHistory: s.showHistory,
        authUser: s.user,
        open: s.menuOpen,
    }));

    const openMenu = (isOpen) => () => {
        setMenuOpen(isOpen);
    }
    return {
        open,
        openMenu,
        showHistory,
        authUser,
        setMenuOpen,
    }
}
